import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex items-center relative h-10" };
const _hoisted_2 = { class: "absolute right-0" };
import { DotsVerticalIcon, FolderIcon, TextInputIcon, Trash01Icon, } from '@gohighlevel/ghl-icons/24/outline';
import { renderIcon, UIButton, UICard, UIDropdown, UITextSmMedium, UITooltip, } from '@gohighlevel/ghl-ui';
import { truncate } from 'lodash';
import { h } from 'vue';
import { useI18n } from 'vue-i18n';
import useEmitter from '../composable/useEmitter';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FolderComponent',
    props: {
        folder: {},
        activeItem: {}
    },
    setup(__props) {
        const emitter = useEmitter();
        const { t } = useI18n();
        const props = __props;
        const contextMenuItems = [
            {
                icon() {
                    return h(renderIcon(TextInputIcon), null, {});
                },
                label: t('common.rename'),
                key: 'rename',
            },
            {
                icon() {
                    return h(renderIcon(Trash01Icon), null, {});
                },
                label: t('common.delete'),
                key: 'delete',
                disabled: props.folder.isEssential,
            },
        ];
        const onChangeOption = e => {
            switch (e) {
                case 'rename':
                    emitter.emit('renameObject', props.folder);
                    break;
                case 'delete':
                    emitter.emit('deleteFileFolder', {
                        id: props.folder._id,
                        type: props.folder.type,
                        name: props.folder.name,
                    });
                    break;
                default:
                    break;
            }
        };
        return (_ctx, _cache) => {
            var _a;
            return (_openBlock(), _createBlock(_unref(UICard), {
                class: _normalizeClass(['cursor-pointer', 'folder-card-wrapper', 'shadow-xs']),
                id: (_a = _ctx.folder) === null || _a === void 0 ? void 0 : _a._id
            }, {
                default: _withCtx(() => {
                    var _a;
                    return [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", null, [
                                _createVNode(_unref(FolderIcon), {
                                    id: (_a = _ctx.folder) === null || _a === void 0 ? void 0 : _a._id,
                                    class: "w-5 h-5"
                                }, null, 8, ["id"])
                            ]),
                            _createVNode(_unref(UITextSmMedium), { class: "truncate ml-2 text-black w-9/12" }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(UITooltip), null, {
                                        trigger: _withCtx(() => {
                                            var _a;
                                            return [
                                                _createTextVNode(_toDisplayString(_unref(truncate)((_a = _ctx.folder) === null || _a === void 0 ? void 0 : _a.name)), 1)
                                            ];
                                        }),
                                        default: _withCtx(() => {
                                            var _a;
                                            return [
                                                _createTextVNode(_toDisplayString((_a = _ctx.folder) === null || _a === void 0 ? void 0 : _a.name), 1)
                                            ];
                                        }),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }),
                            _createElementVNode("div", _hoisted_2, [
                                _createVNode(_unref(UIDropdown), {
                                    options: contextMenuItems,
                                    id: 'folderMenu',
                                    placement: "bottom",
                                    onSelect: onChangeOption
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(UIButton), {
                                            id: "media-folder-dropdown",
                                            type: "default",
                                            size: "small",
                                            disabled: false,
                                            loading: false,
                                            ghost: false,
                                            quaternary: true,
                                            circle: false,
                                            text: false
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_unref(DotsVerticalIcon), { class: "w-5 h-5 text-black cursor-pointer" })
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ])
                        ])
                    ];
                }),
                _: 1
            }, 8, ["id"]));
        };
    }
});
